import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, ControlLabel} from "react-bootstrap";
import Select from "react-select";
import debounce from "lodash/debounce";
import { NotificationManager } from "react-notifications";
import BugsService from "../../../services/BugsService";
import SearchService from "../../../services/SearchService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";

class BugCreateForm extends Component {
    state = {
    	saveBugLoading: false,
    	formData:{},
    	errors: {}
    }

    onChange = (e) => { this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value} }); }
    
    onAsyncChange = (option, name, selected) => { 
    	if (option !== null) {
    		this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.id || "" } });
    	} else {
    		this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
    	}
    }
    
	onSubmit = (e) => {
		e.preventDefault();
		this.setState({saveBugLoading: true, errors: {}});
		this.bugsService.store(this.state.formData).then((res) => {
			this.setState({saveBugLoading: false});
			NotificationManager.success("Bug created.","Success!");
			this.props.history.push("/bugs");	 
		}).catch((err) => {
			this.setState({saveBugLoading: false});
			HandleError(err, this);
		});
	}
    
    handleAsyncSearch = (input = null, attribute, extra, callback) => {
    	if (!input || !input.replace(/\s/g, "").length) {
		 callback(null, { complete: true });
		 return;
    	}
    	this.asyncCallback(input, attribute, extra, callback);
    }

	asyncCallback = debounce((input, attribute, extra, callback) => {
		this.searchService.searchByAttribute(attribute, input, extra).then((res) => {
			callback(null, {options: res.data , complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 700);

	bugsService = new BugsService(this);
    searchService = new SearchService(this);
    
    render() {
    	const { saveBugLoading, formData, errors, selectedUser, selectedProject } = this.state;
    	return (
    		<React.Fragment>
    			<Row>
    				<form onSubmit={this.onSubmit}>
    					<Col md={6} sm={12}>
    						<span className="column-title">Bug details</span>
    						<FormGroup validationState={errors.project_id && "error"}>
    							<ControlLabel>Project</ControlLabel>	
    							<Select.Async
    								onChange={(option) => { this.onAsyncChange(option, "project_id", "selectedProject"); }}
    								name="project_id"
    								placeholder="Choose project"
    								value={selectedProject}
    								labelKey="name"
    								valueKey="id"
    								loadOptions={(e,c)=>this.handleAsyncSearch(e, "project", null, c)}
    								clearable={false}
    								multi={false}
    							/>
    							{errors.project_id && <InlineError text={errors.project_id} />}	
    						</FormGroup>
    						<FormGroup validationState={errors.user_id && "error"}>
    							<ControlLabel>User</ControlLabel>	
    							<Select.Async
    								onChange={(option) => { this.onAsyncChange(option, "user_id", "selectedUser"); }}
    								name="user_id"
    								placeholder="Choose user"
    								value={selectedUser}
    								labelKey="full_name"
    								valueKey="id"
    								loadOptions={(e,c) => this.handleAsyncSearch(e,"user","roles=2,4",c)}
    								clearable={false}
    								multi={false}
    							/>
    							{errors.user_id && <InlineError text={errors.user_id} />}
    						</FormGroup>
    						<Row>
    							<Col md={6} xs={12}>
    								<FormGroup validationState={errors.bug_nr && "error"}>
    									<ControlLabel>Bug number</ControlLabel>                                  
    									<FormControl type="number" name="bug_nr" placeholder="Enter bug number" value={formData.bug_nr || ""} onChange={this.onChange}/>						
    									{errors.bug_nr && <InlineError text={errors.bug_nr} />}								                                							
    								</FormGroup>
    							</Col>
    							<Col md={6} xs={12}>
    								<FormGroup validationState={errors.score && "error"}>
    									<ControlLabel>Bug score</ControlLabel>                                  
    									<FormControl type="number" name="score" placeholder="Enter bug score" value={formData.score || ""} onChange={this.onChange}/>						
    									{errors.score && <InlineError text={errors.score} />}								                                							
    								</FormGroup>
    							</Col>
    						</Row>
    						<FormGroup validationState={errors.description && "error"}>
    							<ControlLabel>Description</ControlLabel>                                  
    							<FormControl componentClass="textarea" name="description" placeholder="Enter bug description"  value={formData.description || ""} onChange={(e)=>this.onChange(e,"formData")}/>						
    							{errors.description && <InlineError text={errors.description} />}								                                							
    						</FormGroup>
              				
    						<Button className="btn-crud" bsStyle="primary" disabled={saveBugLoading} type="submit">{saveBugLoading?"Saving...":"Save"}</Button> 
    						{ saveBugLoading ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }																												
    					</Col>	
    				</form>						
    			</Row>
    		</React.Fragment>
    	);
    }
}
BugCreateForm.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default BugCreateForm;


// WEBPACK FOOTER //
// ./src/components/forms/bugs/BugCreateForm.js